// api/aws/leads/useBatchDeleteLeads.ts
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { useSnackbarContext } from 'context/SnackbarProvider/SnackbarProvider'

type Payload = { ids: string[] }

export function useBatchDeleteLeads() {
  const qc = useQueryClient()
  const { showSnackbar } = useSnackbarContext()
  return useMutation({
    mutationFn: async ({ ids }: Payload) => {
      const { data } = await axios.post(`${baseUrl}/aws/delete/leads-batch`, { ids })
      return data
    },
    onSuccess: (data, variables) => {
      console.log(data, variables)
      qc.invalidateQueries({ queryKey: ['leads'] })
      showSnackbar(data?.message ?? 'Successfully deleted leads', 'success')
    },
  })
}
